import { createArchivedFilter } from '@ayocore/erp/crm/client/components/filters';
import type { DealRepository } from '@ayocore/erp/crm/server/repositories/DealRepository';

/**
 * Фильтр «Архив» для списка сделок.
 * По умолчанию показываем активные; очистка (X) показывает всё.
 */
export const FilterByArchived = createArchivedFilter<DealRepository>({
  applyArchived: (repo, archived) => repo.filterByArchived(archived),
  width: 160,
  logLabel: 'Deal FilterByArchived',
});
